export default __webpack_public_path__ + "static/media/VectorLeft.f32ee89b.svg";